<template>
  <f7-page name="home">
    <!-- Top Navbar -->
    <f7-navbar :sliding="false">
      <f7-nav-left>
        <f7-link v-show="isEnable" icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="left">
        </f7-link>
      </f7-nav-left>
      <f7-nav-title sliding>tipomoika.ru</f7-nav-title>
    </f7-navbar>
    <f7-block v-show="preloader">
      <f7-col class="text-align-center">
        <f7-preloader></f7-preloader>
      </f7-col>
    </f7-block>
    <f7-block-title medium>{{ home.data.attributes.title }}</f7-block-title>
    <f7-block>
      <p v-html="home.data.attributes.description"></p>
    </f7-block>
    <f7-list v-show="isEnable" media-list>
      <f7-list-item title="Записи" link="/history/" v-show="isEnable" :badge="$root.count" badge-color="green">
        <f7-icon slot="media" ios="f7:text_badge_checkmark" md="f7:text_badge_checkmark"></f7-icon>
      </f7-list-item>
    </f7-list>
    <f7-block-title>Информация</f7-block-title>

    <f7-list media-list>
      <f7-list-item :link="home.data.attributes.address.url" external :title="home.data.attributes.address.title"
        :subtitle="home.data.attributes.address.subtitle" target="_blank">
        <f7-icon slot="media" ios="f7:map_pin" md="material:map_pin"></f7-icon>
      </f7-list-item>
      <f7-list-item :title="home.data.attributes.workingTime.time" badge badge-color="green">
        <f7-icon slot="media" ios="f7:timer" md="material:timer"></f7-icon>
      </f7-list-item>

      <f7-list-item :title="$root.phoneFormat(home.data.attributes.phone)" :link="`tel:+7` + home.data.attributes.phone"
        external>
        <f7-icon slot="media" ios="f7:phone" md="material:phone"></f7-icon>
      </f7-list-item>
      <f7-list-item v-show="!isEnable" title="Прайс-лист" link="/price-view/">
        <f7-icon slot="media" icon-aurora="f7:list" ios="f7:square_list" md="material:list"></f7-icon>
      </f7-list-item>
      <f7-list-item v-show="!isEnable" title="Фотогалерея" external target="_blank"
        :link="home.data.attributes.address.gallery_url">
        <f7-icon slot="media" icon-aurora="f7:rectangle_3_offgrid" ios="f7:rectangle_3_offgrid"
          md="f7:rectangle_3_offgrid"></f7-icon>
      </f7-list-item>
    </f7-list>

    <f7-block>
      <f7-row tag="p">
        <f7-col tag="span">
          <f7-button round v-show="isEnable" href="/price/" raised fill>Записаться</f7-button>
          <br />
          <f7-button round v-show="!isEnable" href="/registration/" raised fill>Записаться</f7-button>
        </f7-col>
      </f7-row>
    </f7-block>

    <f7-popup class="demo-popup" :opened="$root.popupOpened" @popup:closed="$root.popupOpened = false">
      <f7-page>
        <f7-navbar title="Автомобиль">
          <f7-nav-right>
            <f7-link popup-close>
              <f7-icon f7="multiply"></f7-icon>
            </f7-link>
          </f7-nav-right>
        </f7-navbar>
        <f7-list no-hairlines-md id="carData">
          <f7-list-input label="Марка автомобиля" name="carBrand" :value="$root.form.data[0].attributes.carBrand"
            @input="
              $root.form.data[0].attributes.carBrand = $event.target.value
            " type="text" placeholder="Toyota Land Cruiser" info="Например, Toyota Land Cruiser"
            error-message="Укажите марку автомобиля" @focus="$root.errorCarBrand = false"
            :error-message-force="$root.errorCarBrand" clear-button></f7-list-input>
          <f7-list-input label="Госномер" name="stateNumber"
            :value="$root.form.data[0].attributes.stateNumber.toUpperCase()" @input="
              $root.form.data[0].attributes.stateNumber = $event.target.value
            " error-message="Госномер русскими буквами с кодом региона — А123ВС56."
            @focus="$root.errorStateNumber = false" :error-message-force="$root.errorStateNumber" type="text"
            placeholder="А001СС196" info="Номер КИРИЛЛИЦЕЙ, например, А001СС196" clear-button></f7-list-input>
          <f7-list-input label="Тип кузова" name="category" :value="$root.form.data[0].attributes.category" @input="
            $root.form.data[0].attributes.category = $event.target.value
          " type="select" error-message="Укажите тип кузова автомобиля" @focus="$root.errorBodyType = false"
            :error-message-force="$root.verrorBodyType" placeholder="Выберите тип кузова...">
            <option :value="category.id" :selected="category.id == $root.form.data[0].attributes.category"
              v-for="(category, index) in $root.categories.data" :key="index">
              {{ category.attributes.title }}
            </option>
          </f7-list-input>
          <f7-list-input label="Цвет" name="color" :value="$root.form.data[0].attributes.color"
            @input="$root.form.data[0].attributes.color = $event.target.value" type="text" placeholder="Черный"
            info="Укажите цвет автомобиля (опционально)" required clear-button></f7-list-input>
        </f7-list>
        <f7-block>
          <f7-row tag="p">
            <f7-button round class="col" @click="$root.checkForm($root.form.data[0].id, $root.btn.text)" fill>{{
                $root.btn.text
            }}</f7-button>
            <template v-if="$root.btn.isEnable">
              <f7-button round class="col" @click="$root.deleteCar($root.form.data[0].id)">Удалить</f7-button>
            </template>
          </f7-row>
        </f7-block>
      </f7-page>
    </f7-popup>

    <Rating :grade="0" :maxStars="5" :hasCounter="true" />
  </f7-page>
</template>


<script>
import Rating from "../components/Rating.vue";

export default {
  components: {
    Rating,
  },
  data() {
    var home = {
      data: {
        type: "homes",
        id: "1",
        attributes: {
          title: "Автомойка",
          description: "Комплексная качественная мойка автомобилей.",
          phone: "9000461819",
          address: {
            title: "Газетная, 81",
            subtitle: "Нижний Тагил, Центр, внутренний двор",
            url: "https://goo.gl/maps/etZTq4899GccMXYP7",
          },
          workingTime: {
            time: "Ежедневно 9:00 — 21:00",
            status: "Открыто",
          },
        },
      },
    };
    return {
      home: home,
      isEnable: this.checkReg(),
      preloader: true,
      count: 0,
    };
  },
  methods: {
    checkReg() {
      var user =  JSON.parse(localStorage.getItem("user"));
      if (
        localStorage.getItem("token") !== null &&
        user !== null && user.name !== ''
      ) {
        return true;
      } else {
        // localStorage.removeItem("user");
        // localStorage.removeItem("token");
        // localStorage.removeItem("isSmsSend");
        return false;
      }
    },
    showNotificationFull(notification) {
      const self = this;
      // Create toast
      if (!self.notificationFull) {
        self.notificationFull = self.$f7.notification.create({
          title: notification.title,
          titleRightText: notification.titleRightText,
          subtitle: notification.subtitle,
          text: notification.text,
          closeTimeout: notification.closeTimeout,
        });
      }
      // Open it
      self.notificationFull.open();
    },
    main() {
      this.$f7ready((f7) => {
        let that = this;
        var goto = localStorage.getItem("goto");
        if (goto !== null) {
          localStorage.removeItem("goto");
          f7.views.main.router.navigate(goto);
        }
        f7.request({
          url: "https://ms.bctip.ru/admin/api/typomojka/v1/homes",
          method: "GET",
          dataType: "json",
          data: "",
          success: function (data, status) {
            if (data.data != null) {
              that.home = data;
              that.preloader = false;
              if (typeof data.data.attributes.notification !== 'undefined') {
                that.showNotificationFull(data.data.attributes.notification);
              }
              return true;
            }
          },
          error: function (XMLHttpRequest, textStatus, errorThrown) {
            let data = JSON.parse(XMLHttpRequest.response);
            if (data.errors != null) {
              data.errors.forEach(function (error) {
                f7.dialog.alert(error.detail, "Ошибка " + error.status);
              });
            } else {
              f7.dialog.alert(errorThrown, "Ошибка " + textStatus);
            }
          },
          beforeSend: function (xhr, settings) {
            xhr.setRequestHeader(
              "authorization",
              "Bearer " + localStorage.getItem("token")
            );
          }, //set tokenString before send
        });
      });
    },
  },
  mounted: function () {
    this.main();
  },
};
</script>


